import "./css/main.css"
// Here we only use jquery.slim because we only need jquery to do some DOM operation.
import './js/bootstrap';
import '../node_modules/flyonui/flyonui.js';
import './js/flyon-ui-extension/hselect';
import './js/flyon-ui-extension/hinputnumber';
import { default as sms_counter } from './js/sms/sms-length';

/*
 |--------------------------------------------------------------------------
 | Midone Built-in Components
 |--------------------------------------------------------------------------
 */

import './js/lucide';
import './js/ajax-tippy';
import './js/datepicker';
import './js/tom-select';
// import "./slimselect";

/*
 |--------------------------------------------------------------------------
 | JS Components
 |--------------------------------------------------------------------------
 */
// import './js/show-dropdown';
import './js/search';

import './js/data-import';
import './js/mms-control';
import './js/app-notification';
import './tailwind-flyui-adapter.js';
import './js/keep-query';
import './theme-control.js';
/* global setTimeout, HSOverlay, HSComboBox, moment */


window.addEventListener('load', () => {
    setTimeout(() => {
        const path = window.location.pathname
        const currentLink =
            document.querySelector(`[data-combo-box-output-item] a[href*="/${path}"]`) ||
            document.querySelector(`[data-combo-box-output-item] a[href*="${path}"]`)

        if (currentLink) {
            currentLink.classList.add('dropdown-active')
            currentLink.closest('[data-combo-box-output-item]').classList.add('combo-box-output-item-highlighted')
        }

        closeAndClearCombobox()
    }, 200)

    // Get scrollbar width
    function getScrollbarWidth() {
        const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
        document.body.style.setProperty('--bs-scrollbar-width', `${scrollbarWidth}px`)
    }
    getScrollbarWidth()
})

function clearSearchbox(combobox) {
    combobox.element.close('')
    combobox.element.setItemsVisibility()
}

function closeAndClearCombobox() {
    const searchOverlay = HSOverlay.getInstance('#search-modal', true)
    const searchCombobox = HSComboBox.getInstance('#search-modal [data-combo-box]', true)
    const clear = document.querySelector('#searchbox-clear')
    const input = document.querySelector('#search-modal [data-combo-box] input')

    if (!searchOverlay || !searchCombobox || !clear) return

    searchOverlay.element.on('open', () => {
        document.body.style.paddingInlineEnd = 'var(--bs-scrollbar-width)'
    })

    window.addEventListener('keydown', function (evt) {
        if (evt.code === 'KeyK' && (evt.ctrlKey || evt.metaKey)) {
            if (searchOverlay.element && searchOverlay.element.el.classList.contains('open')) return false

            searchOverlay.element.open()
            searchCombobox.element.setCurrent()
        }

        // Global Enter key handler for search modal
        if (evt.key === 'Enter' && searchOverlay.element && searchOverlay.element.el.classList.contains('open')) {
            const highlightedItem =
                document.querySelector('#search-modal [data-combo-box-output-item].combo-box-output-item-highlighted') ||
                document
                    .querySelector('#search-modal [data-combo-box-output-item] a:focus')
                    ?.closest('[data-combo-box-output-item]') ||
                document.querySelector('#search-modal li[data-combo-box-output-item]:focus-within')

            if (highlightedItem) {
                evt.preventDefault()
                evt.stopPropagation()

                const linkElement = highlightedItem.querySelector('a[href]')
                if (linkElement && linkElement.href && linkElement.href !== '#') {
                    searchOverlay.element.close()
                    clearSearchbox(searchCombobox)
                    setTimeout(() => {
                        window.location.href = linkElement.href
                    }, 100)
                }
            }
        }
    })
    if (input) {
        input.addEventListener('focus', () => {
            searchCombobox.element.setCurrent()
        })

        input.addEventListener('keydown', evt => {
            if (evt.key === 'ArrowDown') {
                evt.preventDefault()
                if (searchCombobox && searchCombobox.element && typeof searchCombobox.element.next === 'function') {
                    searchCombobox.element.next()
                }
            } else if (evt.key === 'ArrowUp') {
                evt.preventDefault()
                if (searchCombobox && searchCombobox.element && typeof searchCombobox.element.previous === 'function') {
                    searchCombobox.element.previous()
                }
            }
        })
    }

    if (searchOverlay) {
        document.addEventListener('open.hs.overlay', ({ detail }) => {
            if (detail.payload.getAttribute('data-overlay') === '#search-modal') searchCombobox.element.setCurrent()
            return false
        })

        searchOverlay.element.on('close', () => {
            clearSearchbox(searchCombobox)
            document.body.style.paddingInlineEnd = ''
        })
    }

    clear.addEventListener('click', () => clearSearchbox(searchCombobox))
}

// TODO: move this to his own file
$(function () {
    // Ensure moment is available globally for daterangepicker
    if (typeof window.moment === 'undefined') {
        window.moment = moment;
    }
    // Single datetime
    $('input.enable_datetime_pickup').daterangepicker(
        {
            // $('input[class="pickup_datetime"]').daterangepicker({
            singleDatePicker: true,
            minYear: moment().year(),
            // "maxYear": moment().year(),
            // "showWeekNumbers": true,
            timePicker: true,
            autoApply: true,
            locale: {
                // "format": "DD MMMM YYYY HH:mm",
                format: 'YYYY-MM-DD HH:mm', // format support by Django
                // https://docs.djangoproject.com/en/3.2/ref/settings/#datetime-input-formats
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                fromLabel: 'From',
                toLabel: 'To',
                customRangeLabel: 'Custom',
                weekLabel: 'W',
                firstDay: 1,
            },
            timePicker24Hour: true,
            // "startDate": "06/29/2021",
            // "endDate": "07/05/2021",
            drops: 'up',
        },
        function (start) {
            console.log('A new date selection was made: ' + start.format('YYYY-MM-DD HH:mm'));
        }
    );

    // Range
    $('input.enable_datetime_range_pickup').daterangepicker(
        {
            // $('input[class="pickup_datetime"]').daterangepicker({
            singleDatePicker: false,
            minYear: moment().year(),
            // "maxYear": moment().year(),
            // "showWeekNumbers": true,
            timePicker: true,
            autoApply: true,
            locale: {
                // "format": "DD MMMM YYYY HH:mm",
                format: 'YYYY-MM-DD HH:mm', // format support by Django
                // https://docs.djangoproject.com/en/3.2/ref/settings/#datetime-input-formats
                separator: ' - ',
                applyLabel: 'Apply',
                cancelLabel: 'Cancel',
                fromLabel: 'From',
                toLabel: 'To',
                customRangeLabel: 'Custom',
                weekLabel: 'W',
                firstDay: 1,
            },
            timePicker24Hour: true,
            // "startDate": "06/29/2021",
            // "endDate": "07/05/2021",
            drops: 'up',
        },
        function (start) {
            console.log('A new date selection was made: ' + start.format('YYYY-MM-DD HH:mm'));
        }
    );
});

// SMS textarea counter
// --------------------
// $('.textarea_event_counter').on("input", function () {
//   $("#textarea_counter").text($(this).val().length);
// });

// $('.textarea_event_counter').on("paste", function () {
//   console.log("\n\n 1) textarea_event_counter... paste");
// });

$('.textarea_event_counter').on('keyup paste', function () {
    console.log('\n\n 1) textarea_event_counter... keyup paste');
    console.log($('.textarea_event_counter').val());
    $('#textarea_counter').text($(this).val().length);
    let result_counter = sms_counter($('.textarea_event_counter').val());
    // result_counter = { "encoding": "GSM_7BIT", "length": 6, "characterPerMessage": 160, "inCurrentMessage": 6, "remaining": 154, "messages": 1 }
    console.log(result_counter);
    $('.sms_counter__encoding').html(result_counter.encoding);
    $('.sms_counter__length').html(result_counter.length);
    $('.sms_counter__characterPerMessage').html(result_counter.characterPerMessage);
    $('.sms_counter__inCurrentMessage').html(result_counter.inCurrentMessage);
    $('.sms_counter__remaining').html(result_counter.remaining);
    $('.sms_counter__messages').html(result_counter.messages);
});

// // Document is ready | used when refreshing the page
$.when($.ready).then(function () {
    console.log('***********');
    // console.log($(".textarea_event_counter").text());
    console.log($('.textarea_event_counter').val());
    $('.textarea_event_counter').trigger('paste');
});

// --------------------

// Function to loop through all the checkbox and add them to the hidden field store_checked_checkboxes
function store_checked_checkboxes() {
    var list_checked_ID = [];
    $('.checkable-checkbox:checkbox:checked').each(function (i) {
        list_checked_ID[i] = $(this).val();
    });
    $('#store_checkboxes').attr('value', list_checked_ID);
    $('#selected-item-count-text').text(list_checked_ID.length);
}

$('.checkable-checkbox').on('click', function () {
    store_checked_checkboxes();
});

// Toggle Checkboxes
$('#toggle-all-checkboxes').on('click', function () {
    $('.checkable-checkbox').each(function () {
        $(this).prop('checked', $('#toggle-all-checkboxes').is(':checked'));
    });
    store_checked_checkboxes();
});

// Action Checked Checkboxes
$('.action-checked-checkboxes').on('click', function () {
    console.log('action-checked-checkboxes... clicked');
    console.log($('#CheckedCheckboxForm'));
    console.log($(this).data('target-url'));
    $('#CheckedCheckboxForm').attr('action', $(this).data('target-url'));
    // console.log($('#CheckedCheckboxForm'));
    $('#CheckedCheckboxForm').submit();
});

// Start Alpine.js
window.addEventListener('load', () => {
    console.log("Starting Alpine.js...");
    window.Alpine.start();
});

// // Debug scrollTo calls
// // -----------------------
// const oldScrollTo = window.scrollTo;
// window.scrollTo = function () {
//     console.trace("scrollTo called with:", arguments);
//     oldScrollTo.apply(this, arguments);
// };
// console.log("Overwrote window.scrollTo to add debug trace");
// // -----------------------
